var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaasTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 21,
    viewBox: "0 0 40 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 21,
    fill: "url(#pattern2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2598_12386",
    transform: "translate(0.2375) scale(0.00546875 0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2598_12386",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACYElEQVR4nO3aW1ITQRiG4VcN4UbXYShgVR42EwNqia4Ez7oJcAG6BJMrgcKLSYrSKkimp3v+mcn7VPUVmaG7/6ST6f5AkiRJkuo7BF4B58ACuF7TFsvXvgQOAvo7GLvAW+CK9ZN+W7sCToBxy33vvV3gO+kT/3/7hkWo5R35Jn/V3rQ6gh47pNmyc1u7BPZbHEcn3E+45mnides8AJ4UuO/g/CD/u3/VzlocR2/NKVeA3y2OoxPuJVxznb0X/1rXp9L/v6lac1piLVcNFiCYBQhmAYJZgGAWIJgFCDZKuGYBPMzdkaVNHsRSnl06K+UT8Ct7L9q5dyelFOBL9l7c+Fzw3oNxQLV17HZ0oBPyF+B1qyPouTHVMWKuyf+KR5K1jamOEZssR5dU73wnv4F94IjqMGWTs4L58rVHuOZLktSI2dAgZkMDmQ0NZjY0kNnQjMyG9pDZ0GBmQzMyG5qf2dA+sQDBLEAwCxDMAgSzAMEsQDCzocHMhgYzG9pDZkM7wGxoMLOhHWA2tCPMhkqSFGSP6gu1Tjb0DJgBk4D+DsYOcAxckP4z9IKqECmbglttB/hAvgex91iEWo7JvxUxa3UEPbZHs2XnruXocYvj6ISU7ejnlFkuRsCzAvcdnHPyv/tXzWzoBsyGZlQiG9o022k2VO2xAMEsQDALEMwCBLMAwSxAsJQthTnw6I6/N/mdbjZ0AyXzmz8L3ruTUgrwKXsvbnwseO/BmFBmO/oPW7gdnWpG/gJMWx1Bz42AU/JN/ikeSdY2ovokND2Un+LkNzIBXlA/GzrFNV+SJEnSFvoLd4DVHwAj8AcAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaasTools);
export default __webpack_public_path__ + "static/media/saas-tools.5e15705c012fa6869e34f3bfb672da99.svg";
export { ForwardRef as ReactComponent };